import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SurveyService} from "../../../services/surveys.service";
import {Router} from "@angular/router";
import mermaid, {MermaidConfig} from "mermaid";

@Component({
  selector: 'app-survey-tree',
  templateUrl: './survey-tree.component.html',
  styleUrls: ['./survey-tree.component.scss']
})
export class SurveyTreeComponent {
  @ViewChild('mermaid', {static: false}) mermaidDiv!: ElementRef;
  @Input() survey: any;
  @Output() surveyNodeClicked = new EventEmitter();

  constructor(
    private surveyService: SurveyService,
    private router: Router
  ) {
  }

  survey_history = null;
  mermaidDefinition = null;
  loading = false;

  mermaidConfig: MermaidConfig = {
    startOnLoad: false,
    flowchart: {
      useMaxWidth: true,
      htmlLabels: true,
      curve: 'natural',
    },
    securityLevel: 'loose',
  };

  ngOnInit() {
    this.init();
  }

  init() {
    this.loading = true;
    this.surveyService.getSurveyHistoryByID(this.survey?.survey_history_id, (response) => {
      this.survey_history = response;
      this.renderMermaidDiagram();
      this.loading = false;
    }, (err) => {
      this.loading = false;
    })
  }


  generateMermaidDiagram(history: any): string {
    if (!history.surveys || history.surveys.length === 0) {
      return 'flowchart LR\n  NoData["No surveys found"]';
    }

    const sortedSurveys = [...history.surveys].sort((a, b) => {
      if (a.major_version !== b.major_version) {
        return a.major_version - b.major_version;
      }
      return a.minor_version - b.minor_version;
    });

    const surveyMap = new Map<string, any>();
    sortedSurveys.forEach(s => {
      surveyMap.set(`${s.major_version}.${s.minor_version}`, s);
    });

    const nodes: string[] = [];
    const links: string[] = [];

    sortedSurveys.forEach(s => {
      const nodeId = `S_${s.id}`;
      const label = `${s.title} (v${s.version_number})`;

      let styledNode = s.is_draft
        ? `${nodeId}["${label}"]`
        : `${nodeId}["${label}"]:::started`;

      if (s.id === this.survey?.id) {
        styledNode = `${nodeId}["${label}"]:::current`;
      }

      nodes.push(styledNode);

      // Collegamento revisioni verticali (stessa major)
      if (s.minor_version > 0) {
        const prevMinorKey = `${s.major_version}.${s.minor_version - 1}`;
        const prevSurvey = surveyMap.get(prevMinorKey);
        if (prevSurvey) {
          links.push(`S_${prevSurvey.id} --> S_${s.id}`);
        }
      }

      // Collegamento aggiornamenti major (es. 1.0 -> 2.0)
      else if (s.major_version > 1) {
        const prevMajorKey = `${s.major_version - 1}.0`;
        const prevSurvey = surveyMap.get(prevMajorKey);
        if (prevSurvey) {
          links.push(`S_${prevSurvey.id} --> S_${s.id}`);
        }
      }
    });

    const styleBlock = [
      'classDef started fill:#5C39A1,stroke:#333,color:#fff;',
      'classDef current fill:#1F9E99,stroke:#333,color:#fff;'
    ].join('\n');

    return ['flowchart LR', ...nodes, ...links, styleBlock].join('\n');
  }



  renderMermaidDiagram(): void {
    mermaid.initialize(this.mermaidConfig);

    const el = this.mermaidDiv?.nativeElement;

    if (el) {
      this.mermaidDefinition = this.generateMermaidDiagram(this.survey_history)
      mermaid.render('generatedDiagram', this.mermaidDefinition).then((result) => {
        el.innerHTML = result.svg;
        // @ts-ignore
        result.bindFunctions?.();

        const svg = el.querySelector('svg');
        if (svg) {
          const nodes = svg.querySelectorAll('.node');
          nodes.forEach(node => {
            node.addEventListener('click', () => {
              const rawId = node.id;
              const match = rawId.match(/S_(\d+)/);
              if (match) {
                const surveyId = parseInt(match[1], 10);
                this.onNodeClick(surveyId);
              }
            });

            node.addEventListener('mouseenter', () => {
              node.style.cursor = 'pointer';
            });

            node.addEventListener('mouseleave', () => {
              node.style.fill = ''; // reset al colore originale
            });
          });
        }
      }).catch(err => {
        console.error('Mermaid rendering error:', err);
      });
    }
  }

  onNodeClick(surveyID) {
    this.router.navigate(['/']).then(() => {
      this.router.navigate(['/surveys', surveyID]);
    });
  }
}
